import { render, staticRenderFns } from "./StatisticsDashboard.vue?vue&type=template&id=0f11ff0b"
import script from "./StatisticsDashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatisticsDashboard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StatisticsDashboard.vue?vue&type=style&index=0&id=0f11ff0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports